import React from 'react';
import { Section } from './Section';
export function OpeningLead() {
  return <Section className="text-lg md:text-xl leading-relaxed text-brown-light" data-id="element-82">
      <p className="font-serif text-2xl md:text-3xl text-brown mb-8 italic" data-id="element-83">
        If your baby only sleeps on you… it’s not “sweet” right now.
      </p>

      <p className="font-bold text-brown mb-6" data-id="element-84">It’s immobilizing.</p>

      <div className="space-y-6 mb-10" data-id="element-85">
        <p data-id="element-86">
          You’re hungry. You need the bathroom. Your neck hurts. Your phone is
          dying.
        </p>
        <p data-id="element-87">
          And the worst part is the second thought that shows up right after:
        </p>
        <p className="pl-4 border-l-2 border-terracotta italic text-brown" data-id="element-88">
          “Other moms enjoy this… what is wrong with me?”
        </p>
      </div>

      <p className="text-xl md:text-2xl font-serif text-brown mb-6" data-id="element-89">
        Nothing is wrong with you.
      </p>

      <p className="mb-8" data-id="element-90">
        You’re <strong className="text-terracotta" data-id="element-91">nap‑trapped</strong> — and
        you need a plan that works inside that reality.
      </p>

      <div className="bg-white/50 p-6 md:p-8 rounded-2xl border border-brown/5 mb-8" data-id="element-92">
        <h3 className="font-serif text-xl text-brown mb-4" data-id="element-93">
          The Nap‑Trapped Reset is a phone‑first mini ebook that gives you:
        </h3>
        <ul className="space-y-4" data-id="element-94">
          <li className="flex items-start gap-3" data-id="element-95">
            <span className="text-sage text-xl" data-id="element-96">●</span>
            <span data-id="element-97">
              A <strong data-id="element-98">one‑page day map</strong> that creates predictable
              micro‑windows (even with contact naps)
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-99">
            <span className="text-sage text-xl" data-id="element-100">●</span>
            <span data-id="element-101">
              A <strong data-id="element-102">gentle put‑down practice ladder</strong> (no
              crying-it-out, no war)
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-103">
            <span className="text-sage text-xl" data-id="element-104">●</span>
            <span data-id="element-105">
              A <strong data-id="element-106">20‑minute rescue protocol</strong> for the moment your
              day breaks
            </span>
          </li>
        </ul>
      </div>

      <p className="font-medium text-brown" data-id="element-107">
        So you can get your body back — without needing your baby to change
        first.
      </p>
    </Section>;
}